import React, { useState, useEffect }from 'react';

import useCurrentDb from '../hooks/useCurrentDb';
import useCurrentTree, { SheetTree } from '../hooks/useCurrentTree';
import CheckboxTree from 'react-checkbox-tree';
import { deepCopy } from '../general';

import 'react-checkbox-tree/lib/react-checkbox-tree.css';

type LinkTreeNodeType = {
  value: string,
  label: string,
  showCheckbox?: boolean,
  icon?:boolean | undefined,
  children?: LinkTreeNodeType[];
}

type BookTreeForLinkProps = {
  checked: string[]
  setChecked: (checked:string[]) => void
}
const BookTreeForLink: React.FC<BookTreeForLinkProps> = ({checked, setChecked}) => {
  const [, bookId] = useCurrentDb();
  const currentTree = useCurrentTree(bookId);
  const [expanded, setExpanded] = useState<string[]>([]);

  useEffect(() => {
    if (currentTree) {
      let expandIds:string[] = [];    
      expandIds.push(currentTree.id);
      setExpanded(expandIds);
    }
  }, []);

  const toggleCheck = (node:any) => {
    let checkedNow: string[];
    if (checked.find((value) => value === node.value) === node.value) { //チェック済みのシートID
      checkedNow = checked.filter((value) => value !== node.value);
    } else { //チェックがついていないシートID
      checkedNow = deepCopy(checked);
      checkedNow.push(node.value);
    }
    setChecked(checkedNow);
  }

  const makeNodes = (): LinkTreeNodeType[] => {
    if (currentTree && bookId) {  
      const makeTree = (sheetTrees?:SheetTree[]): LinkTreeNodeType[] => {
        let treeValue: LinkTreeNodeType[] = [];                 
        sheetTrees?.forEach(sheetTree => {
          if (sheetTree.children && sheetTree.children.length > 0) {
            treeValue.push({
              value: sheetTree.id,
              label: sheetTree.name,
              children: makeTree(sheetTree.children),
            })
          } else {
            treeValue.push({
              value: sheetTree.id,
              label: sheetTree.name,
            }) 
          }         
        })
        return treeValue;
      }

      const nodeValue: LinkTreeNodeType[] = [{
        value: currentTree.id,
        label: currentTree.name,
        showCheckbox: false,
        children: makeTree(currentTree.children),
      }];

      return nodeValue;
    }
    else {
      let emptyValue: LinkTreeNodeType[] = [];
      return emptyValue;
    }
  }

  if (currentTree && bookId) {
    const nodes:LinkTreeNodeType[] = makeNodes();

    return (
      <CheckboxTree
        nodes={nodes}
        checked={checked}
        expanded={expanded}
        onCheck={check => setChecked(check)}
        onExpand={expand => setExpanded(expand)}
        noCascade={true}
        showNodeIcon={false}
        nativeCheckboxes={true}
        onClick={(node) => toggleCheck(node)}
        icons={{
          expandOpen:"▼",
          expandClose:"▶︎"
        }}      
      />
    )
  } else return <></>
}

export default BookTreeForLink
